(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-utils/assets/react/components/cms-text-formater.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-utils/assets/react/components/cms-text-formater.js');

'use strict';

const tagRules = [{
  open: '<b>',
  close: '</b>',
  render: (content, key) => React.createElement("b", {
    key: key
  }, content)
}, {
  selfClosingRegex: /<br\s*\/?>/gi,
  render: key => React.createElement("br", {
    key: key
  })
}];
const processWrappedTags = _ref => {
  let text = _ref.text,
    tagRule = _ref.tagRule,
    keyPrefix = _ref.keyPrefix;
  const regex = new RegExp("".concat(tagRule.open, "(.*?)").concat(tagRule.close), 'g');
  const output = [];
  let cursor = 0;
  let keyIndex = 0;
  let match = regex.exec(text);
  while (match !== null) {
    const preText = text.slice(cursor, match.index);
    if (preText) {
      output.push(preText);
    }
    output.push(tagRule.render(match[1], "".concat(keyPrefix, "-").concat(keyIndex++)));
    cursor = regex.lastIndex;
    match = regex.exec(text);
  }
  const remainingText = text.slice(cursor);
  if (remainingText) {
    output.push(remainingText);
  }
  return output;
};
const processSelfClosingTags = _ref2 => {
  let nodes = _ref2.nodes,
    tagRule = _ref2.tagRule,
    keyPrefix = _ref2.keyPrefix;
  const output = [];
  nodes.forEach((node, nodeIndex) => {
    if (typeof node !== 'string') {
      output.push(node);
      return;
    }
    const segments = node.split(tagRule.selfClosingRegex);
    segments.forEach((segment, segmentIndex) => {
      if (segment) {
        output.push(segment);
      }
      if (segmentIndex < segments.length - 1) {
        output.push(tagRule.render("".concat(keyPrefix, "-").concat(nodeIndex, "-").concat(segmentIndex)));
      }
    });
  });
  return output;
};
const parseFormattedText = text => {
  if (!text) {
    return '';
  }
  let nodes = [text];
  tagRules.forEach((tagRule, ruleIndex) => {
    const keyPrefix = "tag".concat(ruleIndex);
    if (tagRule.selfClosingRegex) {
      nodes = processSelfClosingTags({
        nodes,
        tagRule,
        keyPrefix
      });
    } else {
      const result = [];
      nodes.forEach((node, nodeIndex) => {
        if (typeof node === 'string') {
          const parsed = processWrappedTags({
            text: node,
            tagRule,
            keyPrefix: "".concat(keyPrefix, "-").concat(nodeIndex)
          });
          result.push(...parsed);
        } else {
          result.push(node);
        }
      });
      nodes = result;
    }
  });
  return nodes;
};
const CmsTextFormatter = _ref3 => {
  let text = _ref3.text;
  return React.createElement(React.Fragment, null, parseFormattedText(text));
};
setGlobal('svs.lyckoplatsen.shared_utils.react.components', {
  CmsTextFormatter
});

 })(window);